import CreditNotesTable from "components/CreditNotes/CreditNotesTable";

const CreditNotes = () => {
    return (
        <CreditNotesTable />
    );
}
export default CreditNotes;
